































/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ButtonConfig } from "../../../Models/Buttons";
import { ParticaEvent, eParticaAction, getActionName } from "../../../Models/ParticaEvent";

import axios from "axios";
import { IIssueConversionService } from "../../../BusinessServices/issueconversion";
import ParticaIssueBase from "../../Base/ParticaIssueBase.vue";
import { IIssueService } from "../../../BusinessServices/issue";
import { ConversionLogModel, IssueStorageDTO, IssueTrackingLogModel, ApiAuditModel, IssueModel, SourceFileModel } from "../../../Generated/ParticaAPI";
import IssueConversionLog from "@/Ui-Components/Issue/IssueConversionLog.vue";
import IssueStatusLog from "@/Ui-Components/Issue/IssueStatusLog.vue";
import IssueTrackingLog from "@/Ui-Components/Issue/IssueTrackingLog.vue";
import { DateUtils } from "../../../BusinessServices/dateutils";
import IssueApiLog from "../../../Ui-Components/Issue/IssueApiLog.vue";


@Component(
	{
		name: "IssueConversion",
		components: {
			ButtonList,
			ParticaCard,
			ParticaView,
			IssueConversionLog,
			IssueStatusLog,
			IssueTrackingLog,
			IssueApiLog
		}
	})
export default class IssueConversion extends ParticaIssueBase {
	@Prop() private id: number;
	private conversionService: IIssueConversionService;
	private issueService: IIssueService;
	private data: ConversionLogModel[] = [];
	private issueStorage: IssueStorageDTO = new IssueStorageDTO();
	private trackingLog: IssueTrackingLogModel[] = [];
	private apilog: ApiAuditModel[] = [];
	private buttons: ButtonConfig[] = [
		// { label: "Add new title", action: eParticaAction.ISSUE_ADD, type: ButtonType.Normal } as ButtonConfig,
	];
	private issue: IssueModel = new IssueModel();
	private sources: SourceFileModel[] = [];

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.PDF_UPLOAD: {
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}

	@Watch("route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Issue Status";
		await this.init();
		await this.getIssueNav(this.id);
	}



	private async init() {
		try {
			this.LoadingStart();
			if (this.stateconfig.admin !== true) {
				return;
			}
			this.conversionService = this.particaServices.getIssueConversionService();
			this.issueService = this.particaServices.getIssueService();
			this.data = await this.conversionService.getConversionLog(this.id);
			this.issueStorage = await this.conversionService.getStorageStatus(this.id);
			this.trackingLog = await this.conversionService.getIssueTrackingLog(this.id);
			this.apilog = await this.conversionService.getApiAudit(this.id);
			this.issue = await this.issueService.getIssue(this.id);
			this.sources = await this.issueService.GetSourceFiles(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
